import React from "react";

//graphQL imports
import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { HttpLink } from "apollo-link-http";
import { ApolloProvider } from "react-apollo";

import typeDefs from "./typeDefs";
import resolvers from "./resolvers";

const cache = new InMemoryCache();
const link = new HttpLink({
  uri: "https://countries.trevorblades.com"
});
const client = new ApolloClient({
  cache,
  link,
  typeDefs,
  resolvers,
  connectToDevTools: true
});

const data = {
  isLoggedIn: true,
  storeSelected: "All Stores"
};

cache.writeData({
  data: {
    isLoggedIn: true
  }
});

client.onResetStore(async () => await cache.writeData({ data }));

const ConfiguredApolloProvider: React.FunctionComponent = ({ children }) => {
  return <ApolloProvider client={client} children={children} />;
};

export default ConfiguredApolloProvider;
